import { render } from "./SampleTypeData.vue?vue&type=template&id=34aaf8b1&scoped=true"
import script from "./SampleTypeData.vue?vue&type=script&lang=js"
export * from "./SampleTypeData.vue?vue&type=script&lang=js"

import "./SampleTypeData.vue?vue&type=style&index=0&id=34aaf8b1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34aaf8b1"]])

export default __exports__